<template>
    <div>
        <!-- 搜索 -->
        <div class="search-inner">
            <a-form layout="inline">
                <a-form-item class="name" label="标题">
                    <a-input class="form-cell" type="text" placeholder="请输入" v-model="title" allow-clear
                        style="width: 303px"></a-input>
                </a-form-item>
                <a-form-item class="search-oper">
                    <a-button type="primary" @click="getList()">查询</a-button>
                </a-form-item>
                <a-form-item style="float: right">
                    <a-button type="primary" icon="plus" @click="open()">新建</a-button>
                </a-form-item>
            </a-form>
        </div>

        <div>
            <a-table :columns="columns" :dataSource="portalList" :pagination="pagination" :loading="loading"
                @change="tableChange" :rowKey="getRowKey">
                <span slot="coverUrl" slot-scope="text">
                    <img class="table-img" :src="text" />
                </span>
                <div slot="enable" slot-scope="status">
                    <p class="status status_success" v-if="status == 1">有效</p>
                    <p class="status" v-else-if="status == 0">无效</p>
                    <p v-else>无</p>
                </div>
                <span slot="action" slot-scope="text, record">
                    <a @click="enable(record)" class="primary" v-if="record.enable == 1">下架</a>
                    <a @click="enable(record)" class="primary" v-else-if="record.enable == 0">上架</a>
                    <a-divider type="vertical" />
                    <a class="primary" @click="open(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a class="primary" @click="deleteNews(record)">删除</a>
                </span>
            </a-table>
        </div>
    </div>
</template>

<script>
import news from "../../api/notice";
//   import moment from "moment";
//   import { log } from "util";

const columns = [
    {
        title: "标题",
        dataIndex: "title",
        width: "15.16%",
    },
    {
        title: "图片",
        dataIndex: "coverUrl",
        scopedSlots: { customRender: "coverUrl" },
        width: "19.3%",
    },
    {
        title: "有效时间",
        dataIndex: "effectiveTime",
        key: "effectiveTime",
        width: "19.39%",
    },
    {
        title: "状态",
        dataIndex: "enable",
        scopedSlots: { customRender: "enable" },
        width: "7.07%",
    },
    {
        title: "上传人",
        dataIndex: "creator",
        key: "creator",
        width: "6.8%",
    },
    {
        title: "修改时间",
        dataIndex: "gmtModified",
        key: "gmtModified",
        width: "17%",
    },
    {
        title: "操作",
        dataIndex: "action",
        scopedSlots: { customRender: "action" },
    },
];

export default {
    data() {
        return {
            title: '',
            columns,
            portalList: [],
            pagination: {},
            loading: false,
            pagination: {
                pageSize: 10,
                total: 0,
                showTotal: (total) => `总共 ${total} 条`, // 显示总数
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "30", "50", "70", "100"],
                current: 1,
                currentPage: 1,
            }, //分页数据对象
        }
    },
    created() {
        this.getList()
    },
    methods: {
        getList() {
            let params = {
                type: 3,
                title: this.title,
                pageSize: this.pagination.pageSize,
                currentPage: this.pagination.current,
            }
            this.loading = true;
            news.listNews(params).then((res) => {
                this.portalList = res.data.list;
                this.loading = false;
                this.pagination = res.data.pagination;
            });
        },
        getRowKey(record, index) {
            return index
        },
        tableChange(pagination) {
            console.log(pagination)
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.getList()
        },
        open(data) {
            this.$router.push({
                path: "/parentNotice/add",
                query: data
            })
        },
        deleteNews(value, index) {
            let self = this
            this.$confirm({
                title: "确定要删除吗?",
                okText: "确定",
                cancelText: "取消",
                content: "删除后，无法撤销",
                onOk() {
                    news.deleteNews(value.id).then((res) => {
                        self.$message.success("删除成功");
                        self.getList()
                    });
                },
            });
        },
        //上下架
        enable(value, index) {
            let self = this;
            let en = "";
            if (value.enable == 0) {
                en = 1;
            } else {
                en = 0;
            }
            news.enable({ id: value.id, enable: en }).then((res) => {
                self.$message.success("操作成功");
                this.getList();
            });
        },
    },
};
</script>
<style lang="less" scoped>
.search-inner {
    margin-bottom: 30px;
}

.table-img {
    width: 160px;
    height: 90px;
    border-radius: 4px;
}
</style>